export default __webpack_public_path__ + "static/media/Trace.7a2e3e23.svg";